"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndividualReviewContainer = exports.NoResultsContainer = exports.NoReviewsContainer = exports.IndividualReviewsContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const framer_motion_1 = require("framer-motion");
const ui_theme_1 = require("@kyruus/ui-theme");
exports.IndividualReviewsContainer = styled_1.default.ul `
  padding: 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.NoReviewsContainer = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')} 0 ${(0, ui_theme_1.fromTheme)('spacing_large')} 0;
  text-align: center;
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
exports.NoResultsContainer = styled_1.default.div `
  max-width: 100%;
  overflow-wrap: break-word;
  overflow: auto;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_large')} 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;

  > span {
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }

  button {
    display: inline;
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
  }
`;
exports.IndividualReviewContainer = (0, styled_1.default)(framer_motion_1.motion.li) `
  list-style: none;
  border-bottom: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  &:last-child {
    border-bottom: none;
  }
`;
//# sourceMappingURL=individual-reviews.styles.js.map